module.exports = __webpack_public_path__ + "img/container.af5e3c72.png";